module.exports = __webpack_public_path__ + "img/page-not-found.fc13a688.svg";